import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import { sprintf } from 'sprintf-js';

import { numberFormat } from '~/common';

import Message from '../message';
import Keyboard from '../keyboard/keyboardInput';


@inject('totoStore', 'dictStore', 'appStore')
@observer
class Header extends Component{

  selectCurrency = (e) => {
    this.props.totoStore.Toto.selectCurrency(e.target.value)
  }

  render() {

    const {data, currencyId, currency, showWarning} = this.props.totoStore.Toto;
    const {cashboxMode} = this.props.appStore;
    const {getLang} = this.props.dictStore;

    return(
      <Fragment>
        <div className="toto-index-top-data">
          <div className="toto-index-row">
            {
              cashboxMode === 2 ?
                <div className="fl_r">
                  <Link to="/rules#r3">{getLang('RULES')}</Link>
                </div>
                :
                null
            }
            <div>
              <Link to="/toto/previous">{getLang('PREVIOUS_DRAWS')}</Link>
            </div>
          </div>
          <div className="toto-index-row clearfix">
            <div className="fl_r">
              <label htmlFor="toto-currency">{getLang('SHOW_IN_CURRENCY')} </label>
              <select className="toto-index-currency" onChange={this.selectCurrency}>
                {Object.keys(data.currency).map(id =>
                  <option key={id} value={data.currency[id].id} selected={data.currency[id].id == currencyId}>{data.currency[id].full_name}</option>
                )}
              </select>
            </div>
            {showWarning ?
              <div className="toto-index-currency-warning">
                {getLang('MAKE_BET_POSSIBLE_ONLY_IN_ACCOUNT_CURRENCY')}
              </div>
            : ''}
          </div>
        </div>
        <div className="toto-index-row">
          <div className="toto-index-current-text">
            <div className="fl_r">
              {getLang('DEADLINE_FOR_BETS_LC')}: <span>{data.date.close}</span>
            </div>
            <div className="toto-index-current">
              {getLang("DRAW")} #R-{data.number}, {data.date.start} - {data.date.end}
            </div>
          </div>
          <div className="toto-index-jackpot">
            <span className="toto-index-jackpot-text">
              {getLang('JACKPOT')}
            </span>
            {data.jackpot[currencyId] ?
              <span> {data.jackpot[currencyId]} {currency.name}</span>
            : <span> {getLang('BET_RESULT_EXPECTED')}</span>}
          </div>
          <div className="toto-index-current-data clearfix">
            <div className="fl_r">
              {getLang('AS_OF_LC')}: {data.date.now} </div>
            <div className="toto-index-pool fl_l">
              <span className="toto-index-pool-text">
                {getLang('POOL')}
              </span> <span>{data.pool[currencyId]} {currency.name}</span>
            </div>
            <div className="toto-index-bet-count fl_l">
              <span className="toto-index-bet-count-text">
                {getLang('BETS_OF')}
              </span> <span id="toto-bet-count">
                {data.bets_count}
              </span>
            </div>
            <div className="toto-index-option-count fl_l">
              <span className="toto-index-option-count-text">
                {getLang('OPTIONS_OF')}:
              </span> <span>{data.cards_count}</span>
            </div>
          </div>
        </div>
        <div className="toto-index-row clearfix">
         {/* <div className="fl_r">
            <button id="toto-index-packet" type="button" className="flat_button button_fixed_width">Пакетная ставка</button>
          </div>*/}
          <div className="toto-index-row toto-index-row-previous clearfix">
            <div style={{ marginTop: '4px'}}>
              <Link to={`/toto/result/${data.previous.id}`}> {getLang('PREVIOUS_DRAW')}  №{data.previous.number}</Link> - {getLang('MAXIMUM_GUESSED_RESULTS')} - {data.previous.guessed} </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

@inject('totoStore', 'dictStore')
@observer
class Footer extends Component{
  state = {
    isDisabledBetButton: false,
  };

  clear = () => {
    this.props.totoStore.Toto.clearAll();
  }

  random = () => {
    this.props.totoStore.Toto.random(1);
  }

  random2 = () => {
    this.props.totoStore.Toto.random();
  }

  handleChange = (val) => {
    this.props.totoStore.Toto.inputAmount(val);
  }

  copy = () => {
    this.props.totoStore.Toto.copy();
  }

  dobet = () => {
    this.setState({ isDisabledBetButton: true });
    this.props.totoStore.Toto.dobet().then(() => {
      this.setState({ isDisabledBetButton: false });
    });
  }

  hideResult = () => {
    this.props.totoStore.clearResult();
  }

  hideSuccess = () => {
    this.props.totoStore.Toto.hideSuccess();
  }

  render(){

    const {result} = this.props.totoStore;
    const {data, currencyId, currency, amount, count, success, minAmount} = this.props.totoStore.Toto;
    const {getLang} = this.props.dictStore;

    return(
      <Fragment>
        <div className="toto-index-controls clearfix">
            <div className="toto-index-controls-item">
                <div className="fl_r buttons">
                    <button type="button" id="toto-clear" className="flat_button button_fixed_width" onClick={this.clear}>{getLang('CLEAR')}</button>
                </div>
                <div className="toto-index-controls-label fl_l">{getLang('SELECTION_OF_OUTCOMES')}:</div>
                <div className="toto-index-controls-data toto-index-controls-button">
                    <button type="button" className="flat_button button_fixed_width" onClick={this.random}>{getLang('ALL')}</button>
                    <button type="button" className="flat_button button_fixed_width" onClick={this.random2}>{getLang('UNSELECTED')}</button>
                </div>
            </div>
            <div className="toto-index-dobet-cont fl_r">
                <button
                  type="button"
                  className="flat_button button_fixed_width"
                  onClick={this.dobet}
                  disabled={this.state.isDisabledBetButton}
                >
                  {getLang('MAKE_BET')}
                </button>
            </div>
            <div className="toto-index-controls-item toto-index-controls-item-1 fl_l">
                <div className="toto-index-controls-label fl_l">
                    {getLang('OPTIONS_SELECTED')}:
                </div>
                <div className="toto-index-controls-data toto-index-controls-text">
                    <span>{count}</span>
                </div>
            </div>
            <div className="toto-index-controls-item toto-index-controls-item-2 fl_l">
                <div className="toto-index-controls-label fl_l">
                    {getLang('AMOUNT_FOR_1_OPTION')}:
                </div>
                <div className="toto-index-controls-data toto-index-controls-text">
                    <div className="fl_l toto-amount-per-option">{numberFormat(amount.per_option, 2, ',', ' ')}</div>
                    <div className="fl_l">{currency.name}</div>
                </div>
            </div>
            <div className="toto-index-controls-item toto-index-controls-item-1 fl_l">
                <div className="toto-index-controls-label fl_l">
                    {getLang('MINIMUM_AMOUNT')}:
                </div>
                <div className="toto-index-controls-data toto-index-controls-text">
                    <a onClick={this.copy}>{numberFormat(amount.min, 2, ',', ' ')}</a>
                <span> {currency.name}</span>
                </div>
            </div>
            <div className="toto-index-controls-item toto-index-controls-item-2 fl_l">
                <div className="toto-index-controls-label fl_l">
                    {getLang('BET_AMOUNT')}:
                </div>
                <div className="toto-index-controls-data toto-index-controls-input">
                    <label>
                      {/*<input id="toto-amount" className="input toto-index-amount" type="text" pattern="\d+([.,]\d{1,2})?" />*/}
                    <Keyboard
                      id="toto-amount"
                      type="text"
                      className="input toto-index-amount"
                      maxLength={6}
                      onChange={this.handleChange}
                      value={amount.current ? amount.current : ''}
                      autoComplete="off"
                      positionX="right"
                      positionY="top"
                    />
                    </label>
                <span> {currency.name}</span>
                </div>
            </div>
        </div>
      {result.status ? <Message text={result.text} onClose={this.hideResult}/> : ''}
      {success ?
        <div class="result-container">
          <div class="result-close right" onClick={this.hideSuccess}></div>
          {/*<div class="result-text">{getLang('BET')} <Link to={`/toto/bet/${success.id}`}>{success.number}</Link> успешно принята. Вариантов: {success.count}; сумма: {success.amount}.</div>*/}
          <div class="result-text">{getLang('BET')} <Link to={`/toto/bet/${success.id}`}>{success.number}</Link> {sprintf(getLang('IRM_TOTO_DOBET_SUCCESS_1'), success.count, success.amount)}</div>
        </div>
      : ''}
      <div className="toto-course-cont clearfix">
        <div className="fl_l toto-course-text">
            {getLang('MINIMUM_RATES_FOR_CURRENT_TOTO')}:
        </div>
        <div className="fl_l">
          <ul className="toto-course-list">
            {Object.keys(data.currency).map(id =>
              <li key={`cur_${id}`} className="fl_l">{data.currency[id].min_str} {data.currency[id].name}</li>
            )}
            </ul>
        </div>
      </div>
      </Fragment>
    )
  }
}

@inject('totoStore', 'dictStore')
@observer
class List extends Component{

  checkOdd = (id, el, indx) => {
    const v = el ? 0 : 1;
    this.props.totoStore.Toto.checkOdd(id, v, indx, 1);
  }

  render() {

    const {data, list} = this.props.totoStore.Toto;
    const {getLang} = this.props.dictStore;
    let number = 0;

    return(
        <div className="toto-table-cont">
          <table className="toto-table">
            <thead>
            <tr>
              <th rowSpan="2">#</th>
              <th rowSpan="2">{getLang('DATE')}</th>
              <th rowSpan="2" colSpan="2">{getLang('EVENT')}</th>
              <th colSpan="3">{getLang('OUTCOME')}</th>
              <th colSpan="3">{getLang('POOL_DISTRIBUTION')}</th>
            </tr>
            <tr>
              <th>1</th>
              <th>X</th>
              <th>2</th>
              <th>1</th>
              <th>X</th>
              <th>2</th>
            </tr>
            </thead>
            <tbody>
              { Object.keys(data.sport).map(sid => {
                const league = data.sport[sid].league;
                return (
                  league.map(lid =>
                    <Fragment key={`tr_${lid}`}>
                      <tr>
                        <td className="toto-table-league-name" colSpan="10">{data.dict.sport[sid]}. {data.dict.league[lid]}</td>
                      </tr>
                      {data.league[lid].games.map((gid, idx) => {
                        ++number;
                        return(
                          <tr className="toto-index-game"  key={`td_${gid}`}>
                            <td className="toto-table-id">{number}</td>
                            <td className="toto-table-date">{data.games[gid].date}</td>
                            <td className="toto-table-cmd">{data.dict.cmd[data.games[gid].c1_id]}</td>
                            <td className="toto-table-cmd">{data.dict.cmd[data.games[gid].c2_id]}</td>
                            {list.get(gid).o.map((el, indx) =>
                              <td key={`check_${indx}`} className="toto-table-checkbox">
                                <div className={`toto-index-checkbox checkbox${el ? ' on' : ''}`} onClick={() => this.checkOdd(gid, el, indx)} >
                                  <span></span>
                                </div>
                              </td>
                            )}
                            <td className={`toto-table-pool-d${list.get(gid).o[0] ? ' toto-index-table-pool-d-selected' : ''}`}>{data.games[gid].percent_1}%</td>
                            <td className={`toto-table-pool-d${list.get(gid).o[1] ? ' toto-index-table-pool-d-selected' : ''}`}>{data.games[gid].percent_X}%</td>
                            <td className={`toto-table-pool-d${list.get(gid).o[2] ? ' toto-index-table-pool-d-selected' : ''}`}>{data.games[gid].percent_2}%</td>
                          </tr>
                       )})}
                    </Fragment>
                  )
                )}
              )}
                </tbody>
            </table>
        </div>
    )
  }
}

@inject('totoStore', 'dictStore')
@observer
export default class TotoContainer extends Component{
  render() {

    const {data, list} = this.props.totoStore.Toto;
    const {getLang} = this.props.dictStore;
    let number = 0;

    return(
        <div className="toto-index">
          <Header />
          <List />
          <Footer />
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/toto/toto.jsx